const URL_PROTOCOL_REGEXP = /^https?:\/\//;

/*
 * This method is a server-side safe aka isomorphic way of getting referrer
 * NOTE: There is no need to pass in a `doc` argument in application code.
 * It's only a parameter here for unit testing!
 */
export function getReferrer(isomorphicLocation, doc) {
  if (typeof document === 'undefined' && typeof doc === 'undefined') {
    return '';
  }

  if (!doc) {
    doc = document;
  }

  const referrer = isomorphicLocation.query.bucketing_referrer || doc.referrer;
  return referrer.replace(URL_PROTOCOL_REGEXP, '');
}


/*
 * Returns `null` if you should not set a custom referrer on GA,
 * the correct referrer string otherwise
 */
export function getReferrerForGA(isomorphicLocation) {
  return isomorphicLocation.query.bucketing_referrer || null;
}
